var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-modal",
    {
      attrs: {
        id: "modal-discount",
        title: _vm.$t("message.campaign_treesoft_review_modal_title"),
        hideHeaderClose: true,
        okOnly: "",
        size: "lg"
      },
      scopedSlots: _vm._u([
        {
          key: "modal-footer",
          fn: function(ref) {
            var ok = ref.ok
            return [
              _c("div", { staticClass: "footer" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-light",
                    on: {
                      click: function() {
                        return ok()
                      }
                    }
                  },
                  [
                    _vm._v(
                      "\n        " + _vm._s(_vm.$t("button.close")) + "\n      "
                    )
                  ]
                )
              ])
            ]
          }
        }
      ])
    },
    [
      _c("div", { staticClass: "container p-0" }, [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-md-12" }, [
            _c("p", { staticClass: "mb-0" }, [
              _vm._v(
                "\n          " +
                  _vm._s(_vm.$t("message.campaign_treesoft_review_content_1")) +
                  "\n        "
              )
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "\n          " + _vm._s(_vm.content2Message) + "\n        "
              )
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-md-12" }, [
            _c(
              "div",
              {
                staticClass: "text-center",
                staticStyle: {
                  border: "1px #ccc dashed",
                  padding: "25px 0 25px 0"
                }
              },
              [
                _c("p", [
                  _c("strong", [
                    _vm._v(
                      "\n              " +
                        _vm._s(
                          _vm.$t("message.campaign_treesoft_review_content_3")
                        ) +
                        "\n            "
                    )
                  ])
                ]),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "btn btn-web",
                    on: {
                      click: function($event) {
                        return _vm.$emit("onSubmit")
                      }
                    }
                  },
                  [
                    _vm._v(
                      "\n            " +
                        _vm._s(
                          _vm.$t("message.campaign_treesoft_review_content_4")
                        ) +
                        "\n            "
                    ),
                    _c("i", { staticClass: "fas fa-external-link-alt" })
                  ]
                )
              ]
            )
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "row mt-3" }, [
          _c("div", { staticClass: "col-md-12" }, [
            _c("p", [
              _vm._v(
                "\n          " +
                  _vm._s(_vm.$t("message.campaign_treesoft_review_content_8")) +
                  "\n        "
              )
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "\n          " +
                  _vm._s(_vm.$t("message.campaign_treesoft_review_content_9")) +
                  "\n        "
              )
            ])
          ])
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-60352af9", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-60352af9","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/base/BaseModalGetDiscount.vue
// module id = null
// module chunks = 